import React from 'react';

import useMediaInfo from 'hooks/useMediaInfo';

const withMediaInfo =
  (...args) =>
  WrappedComponent =>
  props => {
    const mediaInfo = useMediaInfo(...args);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <WrappedComponent mediaInfo={mediaInfo} {...props} />;
  };

export default withMediaInfo;
